export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS";
export const GET_NOTIFICATION = "GET_NOTIFICATION";
export const POST_CREATE_NOTIFICATION = "POST_CREATE_NOTIFICATION";
export const PUT_UPDATE_NOTIFICATION = "PUT_UPDATE_NOTIFICATION";
export const DELETE_NOTIFICATION = "DELETE_NOTIFICATION";
